/* eslint-disable jsx-a11y/anchor-is-valid */
import {Link, useParams} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {BASE_URL} from '../../config'
import {useQuery} from 'react-query'
import axios from 'axios'
import {IArticleList, PartialArticleWithDate} from '../core/_model'
import CardSkeleton from '../../../utils/components/Skeleton/CardSkeleton'
import {formatDateAsDayAndTime} from '../../../utils/helperFunction/_helper'

const GET_ARTICLE_BY_ID = `${BASE_URL}/api/protect/getKnoledgeById`

const ArticleDetails = () => {
  const {id} = useParams()

  const {isLoading, data, error} = useQuery({
    queryKey: ['articleById'],
    queryFn: async () => {
      const response = await axios.get<PartialArticleWithDate>(`${GET_ARTICLE_BY_ID}/${id}`)
      console.log(response)
      const data = await response.data
      return data
    },
    enabled: !!id,
  })

  return (
    <>
      {isLoading && !data ? (
        <div>
          <p className='fs-5 fw-bold text-gray-800 mb-4'>Processing article..</p>
          <CardSkeleton />
          <CardSkeleton />
        </div>
      ) : (
        <>
          <div className={`card`}>
            {/* begin::Body */}
            <div className='card-body pb-0'>
              {/* begin::Header */}
              <div className='d-flex align-items-center mb-5'>
                {/* begin::User */}
                <div className='d-flex align-items-center flex-grow-1'>
                  {/* begin::Avatar */}
                  <div className='symbol symbol-40px me-5'>
                    <span className='symbol-label bg-light-success'>
                      <KTIcon iconName='abstract-26' className='fs-2 text-success' />
                    </span>
                  </div>
                  {/* end::Avatar */}

                  {/* begin::Info */}

                  <div className='d-flex flex-column'>
                    <Link
                      to={`/knowledgebase/article/${data?.id}`}
                      className='text-dark text-hover-primary fs-4 fw-bold'
                    >
                      {data?.title}
                    </Link>
                    <span className='text-gray-700 fw-semibold'>
                      By: {data?.user_name} | Created: {formatDateAsDayAndTime(data?.created_at!)}
                    </span>
                  </div>
                  {/* end::Info */}
                </div>
                {/* end::User */}
              </div>
              {/* end::Header */}

              {/* begin::Post */}
              <div className='mb-5'>
                {/* begin::Image */}
                {/* <div
                  className='bgi-no-repeat bgi-size-cover rounded min-h-250px mb-5'
                  style={{
                    backgroundImage: `url('${toAbsoluteUrl('/media/stock/900x600/20.jpg')}')`,
                  }}
                ></div> */}
                {/* end::Image */}

                {/* begin::Text */}
                <div className='text-gray-800 mb-5 fs-5'   dangerouslySetInnerHTML={{ __html: data?.description! }}></div>
                {/* end::Text */}
              </div>
              {/* end::Post */}
            </div>
            {/* end::Body */}
          </div>
        </>
      )}
    </>
  )
}

export default ArticleDetails
